<div *ngIf="surveyViewerService.activeSurvey$ | async" style="overflow: hidden">
  <div *ngIf="displayImageSelectionLabel(question.imageSelection)" class="mb-4">
    {{ question.imageSelection.selectLabel | translateLabel: activeLang }}
    ({{ question.getSelectedStatementsCount(questionFormControl) + '/' + question.rowKeys.length }})
  </div>

  <div *ngIf="displayLastImageSelectionLabel(question.imageSelection)" class="mb-4">
    {{ question.imageSelection.selectLastLabel | translateLabel: activeLang }}
  </div>
  <ng-container *ngIf="!isSmallScreen">
    <div id="imageFormBig" data-testId="imageForm"
         [style]="{'grid-template-columns': 'repeat(auto-fill, minmax(min(100%, ' + (question.imageSelection.preferredWidth ?? 350) + 'px), 1fr))'}">
      <ng-container *ngFor="let sKey of question.statementsOrder">
        <div
          class="image-container"
          data-testId="image"
          [class]="{'selected': displayRowLabel(sKey, questionFormControl)}"
          [style.max-width]="(question.imageSelection.preferredWidth ?? 350) + 'px'"
          [style.max-height]="(question.imageSelection.preferredWidth ?? 350) + 'px'"
          [style.opacity]="disableImageSelection(sKey, questionFormControl) ? 0.25 : 0.85"
          (click)="selectImage(sKey, questionFormControl, $event)">
          <ng-container *ngIf="surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)">
            <picture>
              <source
                srcset="{{buildImageUrlWithoutWidthParameter(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)) + '?w=1280'}}"
                media="(min-width: 1280px)"
              >
              <source
                srcset="{{buildImageUrlWithoutWidthParameter(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)) + '?w=768'}}"
                media="(min-width: 768px)"
              >
              <source
                srcset="{{buildImageUrlWithoutWidthParameter(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)) + '?w=480'}}"
                media="(min-width: 480px)"
              >
              <img class="img-selectable"
                   src="{{buildImageUrlWithoutWidthParameter(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang))}}"
                   alt="image">
            </picture>
            <ng-container *ngIf="question.imageSelection.showLabel !== false">
              <div [style.opacity]="disableImageSelection(sKey, questionFormControl) ? 0.25 : 0.85"
                   [style.font-size]="(question.imageSelection.labelSize ?? 14) + 'px'"
                   class="image-col-label"
                   *ngIf="question.statements[sKey].label | translateLabel: activeLang as statementLabel">{{ statementLabel }}
              </div>
            </ng-container>

            <button *ngIf="surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)"
                    data-prevent="true"
                    (click)="openImageDialog(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang))">
              <mat-icon class="image-zoom">zoom_in</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="!surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)">
            <ng-container *ngIf="question.imageSelection.showLabel !== false">
              <div
                [style.font-size]="(question.imageSelection.labelSize ?? 14) + 'px'"
                class="label-for-image"
                *ngIf="question.statements[sKey].label | translateLabel: activeLang as statementLabel">{{ statementLabel }}
              </div>
            </ng-container>
          </ng-container>

          <div class="image-row-label"
               [style.opacity]="disableImageSelection(sKey, questionFormControl) ? 0.25 : 0.85"
               [style.background-color]="question.rows[question.findRowKeyOfSelectedImage(sKey, questionFormControl)].color"
               *ngIf="displayRowLabel(sKey, questionFormControl) as rowStatementLabel">{{ rowStatementLabel|translateLabel: activeLang }}
          </div>

        </div>
      </ng-container>
    </div>

    <ng-container *ngFor="let rKey of question.rowsOrder">
      <ng-container *ngFor="let sKey of question.statementsOrder">
        <ng-container
          *ngIf="questionFormControl.get(rKey).get(question.commentsControlName).get(sKey) && questionFormControl.get(rKey).get(question.formControlName).get(sKey).value">
          <mat-form-field [color]="'primary'" class="w-full">
            <mat-label>{{ 'Expliquez votre choix'|transloco }}
              ({{ (question.rows[rKey].label | translateLabel: activeLang) + ': ' + (question.statements[sKey].label | translateLabel: activeLang) }}
              )
            </mat-label>
            <input appNoPaste [errorStateMatcher]="errorMatcher" type="text" matInput
                   [formControl]="$any(questionFormControl.get(rKey).get(question.commentsControlName).get(sKey))"
                   (input)="onInput($event.target.value, sKey, rKey)"
                   (blur)="onBlur($event.target.value.trim(), sKey, rKey)">
            <mat-error>
              {{ 'Le commentaire ne peut être vide'|transloco }}.
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="isValidAI?.[rKey]?.[sKey]| async as isValidAI">
            <div class="warning-message mb-8" *ngIf="!isValidAI.isValid">**** {{ isValidAI.explication }}</div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isSmallScreen">

    <div id="imageFormSmall" data-testId="imageFormSmall"
         [style]="{'grid-template-columns': 'repeat(auto-fill, minmax(min(100%, ' + (question.imageSelection.preferredWidth ?? 150) + 'px), 1fr))'}">

      <div *ngFor="let sKey of question.statementsOrder" data-testId="image"
           [style.opacity]="disableImageSelection(sKey, questionFormControl) ? 0.25 : 0.85"
           class="image-container"
           (click)="selectImage(sKey, questionFormControl, $event)">
        <div
          style="margin: auto"
          [class]="{'selected': displayRowLabel(sKey, questionFormControl)}"
          [style.max-width]="(question.imageSelection.preferredWidth ?? 350) + 'px'"
          [style.max-height]="(question.imageSelection.preferredWidth ?? 350) + 'px'">
          <ng-container *ngIf="surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)">
            <picture
              *ngIf="surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)">
              <source
                srcset="{{buildImageUrlWithoutWidthParameter(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)) + '?w=1280'}}"
                media="(min-width: 1280px)"
              >
              <source
                srcset="{{buildImageUrlWithoutWidthParameter(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)) + '?w=768'}}"
                media="(min-width: 768px)"
              >
              <source
                srcset="{{buildImageUrlWithoutWidthParameter(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)) + '?w=480'}}"
                media="(min-width: 480px)">
              <img class="img-selectable"
                   src="{{buildImageUrlWithoutWidthParameter(surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang))}}"
                   alt="image">
            </picture>
            <ng-container *ngIf="question.imageSelection.showLabel !== false">
              <div [style.opacity]="disableImageSelection(sKey, questionFormControl) ? 0.25 : 0.85"
                   [style.font-size]="(question.imageSelection.labelSize ?? 14) + 'px'"
                   class="image-col-label"
                   *ngIf="question.statements[sKey].label | translateLabel: activeLang as statementLabel">{{ statementLabel }}
              </div>
            </ng-container>
            <div [style.opacity]="disableImageSelection(sKey, questionFormControl) ? 0.25 : 0.85"
                 class="image-row-label"
                 *ngIf="displayRowLabel(sKey, questionFormControl) as rowStatementLabel">{{ rowStatementLabel|translateLabel: activeLang }}
            </div>
          </ng-container>
          <ng-container *ngIf="!surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)">
            <ng-container *ngIf="question.imageSelection.showLabel !== false">
              <div
                [style.font-size]="(question.imageSelection.labelSize ?? 14) + 'px'"
                class="label-for-image"
                *ngIf="question.statements[sKey].label | translateLabel: activeLang as statementLabel">{{ statementLabel }}
              </div>
            </ng-container>
            <div [style.opacity]="disableImageSelection(sKey, questionFormControl) ? 0.25 : 0.85"
                 class="image-row-label"
                 *ngIf="displayRowLabel(sKey, questionFormControl) as rowStatementLabel">{{ rowStatementLabel|translateLabel: activeLang }}
            </div>
          </ng-container>


          <ng-container
            *ngIf="questionFormControl.get(question.findRowKeyOfSelectedImage(sKey, questionFormControl)) && questionFormControl.get(question.findRowKeyOfSelectedImage(sKey, questionFormControl)).get(question.formControlName).get(sKey).value && question.isOpenStatement(question.findRowKeyOfSelectedImage(sKey, questionFormControl), sKey)">
            <mat-form-field data-prevent="true" [color]="'primary'" class="selection-comment">
              <mat-label>{{ 'Expliquez votre choix.'|transloco }}.
                ({{ displayRowLabel(sKey, questionFormControl) | translateLabel: activeLang + ': ' + (question.statements[sKey].label | translateLabel: activeLang) }}
                )
              </mat-label>
              <input appNoPaste [errorStateMatcher]="errorMatcher" type="text" matInput
                     [formControl]="$any(questionFormControl.get(question.findRowKeyOfSelectedImage(sKey, questionFormControl)).get(question.commentsControlName).get(sKey))"
                     (input)="onInput($event.target.value, sKey, question.findRowKeyOfSelectedImage(sKey, questionFormControl))"
                     (blur)="onBlur($event.target.value.trim(), sKey, question.findRowKeyOfSelectedImage(sKey, questionFormControl))">
              <mat-error>
                {{ 'Le commentaire ne peut être vide'|transloco }}.
              </mat-error>
            </mat-form-field>
            <ng-container *ngIf="isValidAI?.[question.findRowKeyOfSelectedImage(sKey, questionFormControl)]?.[sKey]| async as isValidAI">
              <div class="warning-message mb-8" *ngIf="!isValidAI.isValid">**** {{ isValidAI.explication }}</div>
            </ng-container>
          </ng-container>

        </div>

      </div>

    </div>
  </ng-container>

  <mat-error
    *ngIf="surveyViewerService.allFormControlsMarkedAsTouched$.value && questionFormControl.hasError(surveyViewerService.requireMinImageSelectionFnName)">
    {{ surveyViewerService.errorMessages.minImageSelection(question.minAnswers.rows)|translateLabel: activeLang }}
  </mat-error>

</div>
